import { useMemo } from "react";
import {
  AvailabilitiesType, BlockedPeriodType, RolesType, UserDataType
} from "../types/user";
import { useAppDispatch, useAppSelector } from "../store";
import {
  doctorAvailabilities, doctorBlockedPeriods, fetchBlockedPeriods,
  fetchUser,
  isUserLoading, userData, userRole, userId
} from "../store/slices/user";

const useCurrentUser = () => {
  const role = useAppSelector(userRole) as NonNullable<RolesType>;
  const isLoading = useAppSelector(isUserLoading);
  const data = useAppSelector(userData) as UserDataType;
  const id = useAppSelector(userId) as string;
  const availabilities = useAppSelector(doctorAvailabilities) as AvailabilitiesType[];
  const blockedPeriods = useAppSelector(doctorBlockedPeriods) as BlockedPeriodType[];
  const finishedAppointmentWithCurrentDoctor = useAppSelector(state => {
    return state.user.finishedAppointmentWithCurrentDoctor;
  });
  const dispatch = useAppDispatch();

  const isDoctor = role === "oncologist" || role === "nutrizionist";

  const refetchUser = () => dispatch(fetchUser());
  const fetchDoctorBlockedPeriods = () => dispatch(fetchBlockedPeriods());

  const isPatientApproved = !!data?.consensoInformato
    ?.some((item) => item.professionist_id === data?.oncologist?.[0]?.id);

  const fullName = useMemo(() => {
    if (data) {
      const { name, surname } = data;

      return `${name ?? ""} ${surname ?? ""}`;
    }
    return "";
  }, [data]);

  return {
    isLoading,
    data,
    role,
    id,
    isDoctor,
    fullName,
    refetchUser,
    finishedAppointmentWithCurrentDoctor,
    fetchDoctorBlockedPeriods,
    availabilities,
    blockedPeriods,
    isPatientApproved
  };
};

export default useCurrentUser;
